/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, array, string, func, arrayOf, shape,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import  DesktopFooterBlock from './DesktopFooterBlock/DesktopFooterBlock';
import ShopTheSiteBanner from '../../../pages/Account/components/GiftList/ShopTheSiteBanner';
import customBreakpoints from '../../../helpers/customBreakpoints';

const styles = (theme) => ({
    desktopFooter: {
        backgroundColor: theme.palette.desktopBgFooter,
        position: 'relative',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            paddingTop: '20px',
        },
    },
});
class DesktopGraphqlFooter extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openDialog: false,
            title: '',
        };
    }

    setTitle(props) {
        if (props.self) {
            props.self.setState({
                title: props.title,
                openDialog: true,
            });
        } else {
            this.setState({
                title: props.title,
                openDialog: true,
            });
        }
    }

    setDialog(props) {
        if (props.self) {
            props.self.setState({
                openDialog: props.close,
            });
        } else {
            this.setState({
                openDialog: false,
            });
        }
    }

    desktopFooter = () => {
        const {
            classes, desktopFooterData, checkTitle, presentationFamily, brand,
        } = this.props;
        const { openDialog, title } = this.state;
        const activeMenuItem = desktopFooterData.filter((mobileFooterItem) => checkTitle(mobileFooterItem.title, 'defaultfooter', 'footer'));
        if (activeMenuItem?.[0]?.footer_blocks?.length) {
            const footerBlocks = activeMenuItem[0].footer_blocks;
            const bottomLinks = footerBlocks.filter((item) => item.footer_bottom_links);
            const popupData = bottomLinks.map((x) => x.footer_bottom_links.link_group.filter((y) => y.popup || (y?.link?.href?.indexOf('About-Us-Terms-of-Use') === 1 || y?.link?.href?.indexOf('t-c') === 1 || y?.link?.href?.indexOf('privacy-policy') === 1 || y?.link?.href?.indexOf('About-Us-Privacy-Policy') === 1 || y?.link?.href?.indexOf('sitemap') === 1 || y?.link?.title?.toLowerCase().includes('cookie') || y?.link?.title?.indexOf('Accessibility Statement') === 1 || y?.link?.title?.toLowerCase().includes('information'))));
            const filtered = popupData.filter((el) => el.length > 0);
            const checkoutPage  = (typeof window === 'object' && !window.location?.pathname?.includes('/checkout/order-confirmation')) ? (/checkout/.test(window.location.pathname)) : false;
            const addonsPage  = (typeof window === 'object') ? (/add-ons/.test(window.location.pathname)) : false;
            return (
                <div className={classes.desktopFooter}>
                    {footerBlocks.map((block, index) => {
                        const keyItem = `desktopFooterBlock${index}`;
                        let setBlock = {};
                        if (checkoutPage || addonsPage) {
                            if (Object.keys(block)[0] === 'copyright') {
                                setBlock = block;
                            }
                        } else {
                            setBlock = block;
                        }

                        return (
                            <DesktopFooterBlock
                                block={setBlock}
                                self={this}
                                setDialog={this.setDialog}
                                setPopupTitle={this.setTitle}
                                key={keyItem}
                                popUpData={filtered[0]}
                                openDialog={openDialog}
                                title={title}
                                presentationFamily={presentationFamily}
                                brand={brand}
                            />
                        );
                    })}
                    <ShopTheSiteBanner />
                </div>
            );
        }
        return (<></>);
    }

    render() {
        return this.desktopFooter();
    }
}
DesktopGraphqlFooter.defaultProps = {
    desktopFooterData: [],
};

DesktopGraphqlFooter.propTypes = {
    desktopFooterData: arrayOf(
        shape({
            footer_blocks: array.isRequired,
            locale: string.isRequired,
            title: string.isRequired,
            uid: string.isRequired,
        }).isRequired,
    ),
    classes: object.isRequired,
    checkTitle: func.isRequired,
    presentationFamily: string.isRequired,
    brand: object.isRequired,
};

export default withStyles(styles)(DesktopGraphqlFooter);
